import { render, staticRenderFns } from "./SkeletonProductList.vue?vue&type=template&id=08f8dcee&scoped=true"
import script from "./SkeletonProductList.vue?vue&type=script&lang=js"
export * from "./SkeletonProductList.vue?vue&type=script&lang=js"
import style0 from "./SkeletonProductList.vue?vue&type=style&index=0&id=08f8dcee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f8dcee",
  null
  
)

export default component.exports